import { render, staticRenderFns } from "./competeAgeGroupList.vue?vue&type=template&id=186a864a&"
import script from "./competeAgeGroupList.vue?vue&type=script&lang=js&"
export * from "./competeAgeGroupList.vue?vue&type=script&lang=js&"
import style0 from "./competeAgeGroupList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports